import { Pending } from './pending'
import { Effected } from './effected'

export const DeclarationsIsa = {
  Pending,
  Effected
}
